<nav class="navbar navbar-expand-lg ">
  <div class="container-fluid">
    <a class="navbar-brand" routerLink="/">
      <img ngSrc="assets/img/medilinkLogo.svg" alt="MediLink Logo" width="150" height="50">
    </a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
<!--    <div class="collapse  navbar-collapse ms-lg-auto " id="navbarSupportedContent">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
        <li class="nav-item">
          <a class="nav-link" routerLinkActive="activeRoute"  routerLink="/promociones"><span>Salud Ocupacional</span></a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLinkActive="activeRoute"   routerLink="/ambulancia"><span>Dispensario</span></a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLinkActive="activeRoute" style="color: var(&#45;&#45;bs-red);" routerLink="/especialidades">Ambulancia</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLinkActive="activeRoute" routerLink="/contactanos">Ferias</a>
        </li>
      </ul>


    </div>-->
  </div>
</nav>



